module.exports = __webpack_public_path__ + "img/power-loss.70104813.svg";